import { atmBackConfiguration } from "@/setup/restAtmBackClient";
import { AtbatApi } from "@socotec.io/atm-back-sdk";

const api = new AtbatApi(atmBackConfiguration);

export const generateAtbatDocuments = async ({ caseNumber, zoneUuids }) => {
  return await api.generate({
    generateAtbatRequest: { caseNumber, zoneUuids },
  });
};
